import React from 'react';
import { useTranslation } from 'next-i18next';
import LendingPlanItem from './lending-plan-item';
import { useLendingPlanData } from '~/hooks/with-lending-data';
import { AppRoutesEnum } from '~/enums/route.enum';
import { renderBalance } from '~/utils/render.util';
import { getLendingPlanDurationTitle } from '~/utils/lending.util';
import { LendingPlanEnum } from '~/enums/lending-plan.enum';

const LendingPlans = () => {
  const { t } = useTranslation('common');

  const { data: seedData, error: seedError } = useLendingPlanData(LendingPlanEnum.SEED);
  const { data: sproutData, error: sproutError } = useLendingPlanData(LendingPlanEnum.SPROUT);
  const { data: harvestData, error: harvestError } = useLendingPlanData(LendingPlanEnum.HARVEST);

  return (
    <div
      className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6"
      data-testid="lending-plans-container"
    >
      <LendingPlanItem
        data-testid="lending-plan-seed"
        title={t('lending_page.seed')}
        durationTitle={getLendingPlanDurationTitle(LendingPlanEnum.SEED, t)}
        link={AppRoutesEnum.LENDING_SEED}
        data={seedData}
        error={seedError}
        descriptions={[
          t('lending_page.plan_description_1', { usdtx: '0.1', joc: '100' }),
          t('lending_page.plan_description_2', { month: 1, day: 30 }),
          ...(seedData
            ? [
                t('lending_page.plan_description_3', {
                  value: renderBalance(seedData.maximumDepositTokens || BigInt(0)),
                }),
              ]
            : []),
        ]}
      />
      <LendingPlanItem
        data-testid="lending-plan-sprout"
        title={t('lending_page.sprout')}
        durationTitle={getLendingPlanDurationTitle(LendingPlanEnum.SPROUT, t)}
        link={AppRoutesEnum.LENDING_SPROUT}
        data={sproutData}
        error={sproutError}
        descriptions={[
          t('lending_page.plan_description_1', { usdtx: '0.4', joc: '100' }),
          t('lending_page.plan_description_2', { month: 3, day: 90 }),
          ...(sproutData
            ? [
                t('lending_page.plan_description_3', {
                  value: renderBalance(sproutData.maximumDepositTokens || BigInt(0)),
                }),
              ]
            : []),
        ]}
      />
      <LendingPlanItem
        data-testid="lending-plan-harvest"
        title={t('lending_page.harvest')}
        durationTitle={getLendingPlanDurationTitle(LendingPlanEnum.HARVEST, t)}
        link={AppRoutesEnum.LENDING_HARVEST}
        data={harvestData}
        error={harvestError}
        descriptions={[
          t('lending_page.plan_description_1', { usdtx: '1.0', joc: '100' }),
          t('lending_page.plan_description_2', { month: 6, day: 180 }),
          ...(harvestData
            ? [
                t('lending_page.plan_description_3', {
                  value: renderBalance(harvestData.maximumDepositTokens || BigInt(0)),
                }),
              ]
            : []),
        ]}
      />
    </div>
  );
};

export default LendingPlans;
